import { useTranslation } from 'react-i18next';

import { getAccessToken } from './tokenStore';
import { readImpersonationClaims } from './impersonation';

/**
 * The read-only impersonation banner (slice 17c).
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * 🔴 THIS EXISTS SO NOBODY MISTAKES A CUSTOMER'S FLEET FOR THEIR OWN.
 * ─────────────────────────────────────────────────────────────────────────────
 * A staff member looking at Abdishakur's dashboard sees Abdishakur's vehicles on
 * Abdishakur's map with Abdishakur's alerts. Nothing else on the screen says
 * whose data it is. Without this, the failure is not a bug report — it is
 * someone acting on a fleet they think is theirs.
 *
 * CLAUDE.md names the same risk for the ADMIN portal's accent colour: "the
 * distinction matters most during impersonation, when the accent may be the only
 * thing telling you whose data is on screen". On `app.` the accent is green
 * either way, because this IS the customer app — so the accent cannot carry the
 * signal here and an explicit banner has to.
 *
 * It is deliberately unmissable and NOT dismissible. A banner that can be closed
 * is a banner that is closed, and the session lasts ten minutes anyway.
 *
 * The `ro` claim is read from the token itself rather than from a flag set
 * beside it, so the banner cannot disagree with what the API will permit.
 */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const { readOnly } = readImpersonationClaims(getAccessToken());

  if (!readOnly) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 bg-raad-warn px-4 py-2 text-center text-[12.5px] font-semibold text-raad-bg"
    >
      <span>{t('impersonation.banner')}</span>
      <span className="font-normal opacity-90">{t('impersonation.readOnly')}</span>
    </div>
  );
}
